import React, { FunctionComponent, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styles from './account-profile.module.scss';
import { IAppState } from '../../../../store';
import { checkAuthentication } from '../../../../lib/auth/actions';

const AccountProfile: FunctionComponent = () => {
  const dispatch = useDispatch();
  // Redux Selectors
  const user = useSelector((state: IAppState) => state.auth?.user);

  useEffect(() => {
    dispatch(checkAuthentication());
  }, [dispatch]);

  if (!user) return <></>;

  return (
    <div className={styles.accountProfile}>
      <h3>Profile</h3>

      <div className={styles.field}>
        <div className={styles.label}>Email</div>
        <div className={styles.inner}>
          <div className={styles.text}>{user.email}</div>
        </div>
      </div>

      <div className={styles.field}>
        <div className={styles.label}>First Name</div>
        <div className={styles.inner}>
          <div className={styles.text}>{user?.firstName || ''}</div>
        </div>
      </div>

      <div className={styles.field}>
        <div className={styles.label}>Last Name</div>
        <div className={styles.inner}>
          <div className={styles.text}>{user?.lastName || ''}</div>
        </div>
      </div>
    </div>
  );
};

export default AccountProfile;
